import useCustomerProductList from '../useCustomerProductList';
import type {ICustomerProductList} from '../useCustomerProductList';

import type {IUseWishlistOptions} from './IUseWishlist';

const DEFAULT_WISHLIST_TYPE = 'wish_list';

const useWishlist = (opts: IUseWishlistOptions = {}): ICustomerProductList => {
	const {wishlistName, wishlistType = DEFAULT_WISHLIST_TYPE} = opts;

	return useCustomerProductList(wishlistName, wishlistType);
};

export default useWishlist;
